(function () {

  const PREMIUM_SERVICE_HANDLE = 'wavon-app-remote-monitoring';
  const CUSHION_HANDLES = ['wavon-cushion'];

  let isProcessing = false;
  let lastCartState = null;

  // Shared rate-limited cart fetcher — both scripts share one /cart.js fetch
  if (!window.__sharedCartFetch) {
    var _sharedPromise = null, _sharedTs = 0;
    window.__sharedCartFetch = function () {
      var now = Date.now();
      if (_sharedPromise && now - _sharedTs < 5000) return _sharedPromise;
      _sharedTs = now;
      _sharedPromise = fetch('/cart.js')
        .then(function (r) { return r.ok ? r.json() : null; })
        .catch(function () { return null; });
      return _sharedPromise;
    };
  }

  function fetchCartSafe() {
    return window.__sharedCartFetch();
  }

  // Cache the variant ID — avoids re-fetching on every add operation
  let _cachedVariantId = null;
  async function getPremiumServiceVariantId() {
    if (_cachedVariantId) return _cachedVariantId;
    try {
      const response = await fetch(`/products/${PREMIUM_SERVICE_HANDLE}.js`);
      if (!response.ok) return null;
      _cachedVariantId = (await response.json()).variants[0].id;
      return _cachedVariantId;
    } catch (err) {
      console.error('Error getting premium service variant:', err);
      return null;
    }
  }

  function hasCushionInCart(cart) {
    return cart.items.some((item) => CUSHION_HANDLES.includes(item.handle));
  }

  function hasPremiumServiceInCart(cart) {
    return cart.items.some((item) => item.handle === PREMIUM_SERVICE_HANDLE);
  }

  function getPremiumServiceKey(cart) {
    const item = cart.items.find(
      (item) => item.handle === PREMIUM_SERVICE_HANDLE
    );
    return item ? item.key : null;
  }

  function waitForCartDrawerRefresh() {
    return new Promise((resolve) => {
      const cartDrawer = document.querySelector('cart-drawer');

      if (!cartDrawer) {
        resolve();
        return;
      }

      let debounceTimer;

      const timeout = setTimeout(() => {
        observer.disconnect();
        resolve();
      }, 6000);

      const observer = new MutationObserver(() => {
        clearTimeout(debounceTimer);
        debounceTimer = setTimeout(() => {
          clearTimeout(timeout);
          observer.disconnect();
          resolve();
        }, 300);
      });

      observer.observe(cartDrawer, {
        childList: true,
        subtree: true
      });
    });
  }

  async function addPremiumService() {
    if (isProcessing) return;

    isProcessing = true;

    const submitBtn = document.querySelector(
      'form[is="product-form"] button[is="custom-button"]'
    );

    if (submitBtn) {
      submitBtn.setAttribute('aria-busy', 'true');
    }

    try {
      const variantId = await getPremiumServiceVariantId();

      if (!variantId) return;

      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          items: [{
            id: variantId,
            quantity: 1
          }]
        })
      });

      if (response.ok) {
        console.log('White Glove Service added successfully');

        document.dispatchEvent(
          new CustomEvent('cart:refresh')
        );

        await waitForCartDrawerRefresh();
      }

    } catch (err) {
      console.error('Error adding premium service:', err);

    } finally {
      if (submitBtn) {
        submitBtn.removeAttribute('aria-busy');
      }

      isProcessing = false;
    }
  }

  async function removePremiumService(cart) {
    if (isProcessing) return;

    isProcessing = true;

    const submitBtn = document.querySelector(
      'form[is="product-form"] button[is="custom-button"]'
    );

    if (submitBtn) {
      submitBtn.setAttribute('aria-busy', 'true');
    }

    try {
      const serviceKey = getPremiumServiceKey(cart);

      if (!serviceKey) return;

      const response = await fetch('/cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          id: serviceKey,
          quantity: 0
        })
      });

      if (response.ok) {
        console.log('White Glove Service removed successfully');

        document.dispatchEvent(
          new CustomEvent('cart:refresh')
        );

        await waitForCartDrawerRefresh();
      }

    } catch (err) {
      console.error('Error removing premium service:', err);

    } finally {
      if (submitBtn) {
        submitBtn.removeAttribute('aria-busy');
      }

      isProcessing = false;
    }
  }

  // Accept cartData from event detail to skip a fetch when possible
  async function manageWhiteGloveService(cartData) {
    if (isProcessing) return;
    try {
      const cart = cartData || await fetchCartSafe();
      if (!cart) return;
      const hasCushion = hasCushionInCart(cart);
      const hasService = hasPremiumServiceInCart(cart);
      const currentCartState = JSON.stringify({ hasCushion, hasService, itemCount: cart.item_count });
      if (currentCartState === lastCartState) return;
      lastCartState = currentCartState;
      console.log('Wavon cart state:', { hasCushion, hasService });
      if (hasCushion && !hasService) {
        await addPremiumService();
      } else if (!hasCushion && hasService) {
        await removePremiumService(cart);
      }
    } catch (err) {
      console.error('Error managing white glove service:', err);
    }
  }

  async function preventCheckoutIfOnlyService(cartData) {
    try {
      const cart = cartData || await fetchCartSafe();
      if (!cart) return;
      const hasService = hasPremiumServiceInCart(cart);
      const hasOtherProducts = cart.items.some((item) => item.handle !== PREMIUM_SERVICE_HANDLE);
      if (hasService && !hasOtherProducts) {
        document.querySelectorAll(
          '[name="checkout"], .cart__checkout-button, button[type="submit"][name="checkout"], [href*="/checkout"]'
        ).forEach((btn) => {
          btn.disabled = true;
          btn.style.opacity = '0.5';
          btn.style.cursor = 'not-allowed';
          btn.title = 'The Wavon App cannot be purchased alone. Please add a Wavon Cushion to your cart.';
          if (btn.tagName === 'A') {
            btn.dataset.originalHref = btn.href;
            btn.removeAttribute('href');
          }
        });
      } else {
        document.querySelectorAll(
          '[name="checkout"], .cart__checkout-button, button[type="submit"][name="checkout"], [data-original-href]'
        ).forEach((btn) => {
          btn.disabled = false;
          btn.style.opacity = '1';
          btn.style.cursor = 'pointer';
          btn.title = '';
          if (btn.dataset.originalHref) {
            btn.href = btn.dataset.originalHref;
            delete btn.dataset.originalHref;
          }
        });
      }
    } catch (err) {
      // FIX: Removed stray extra closing paren that caused a syntax error
      console.error('Error checking cart for checkout:', err);
    }
  }

  // Debounce — collapses rapid-fire events into one check
  let pendingTimer = null;
  function scheduleCartCheck(cartData) {
    clearTimeout(pendingTimer);
    pendingTimer = setTimeout(() => {
      manageWhiteGloveService(cartData);
      preventCheckoutIfOnlyService(cartData);
    }, 1200);
  }

  // Guard only /checkout — NOT /cart/add
  document.addEventListener('submit', async function (e) {
    const form = e.target;
    if (form.action && form.action.includes('/checkout')) {
      const cart = await fetchCartSafe();
      if (cart) {
        const hasService = hasPremiumServiceInCart(cart);
        const hasOtherProducts = cart.items.some((item) => item.handle !== PREMIUM_SERVICE_HANDLE);
        if (hasService && !hasOtherProducts) {
          e.preventDefault();
          e.stopPropagation();
          alert('The Wavon App cannot be purchased alone. Please add a Wavon Cushion to your cart first.');
          return false;
        }
      }
    }
  }, true);

  document.addEventListener('click', async function (e) {
    const link = e.target.closest('a[href*="/checkout"]');
    if (link) {
      const cart = await fetchCartSafe();
      if (cart) {
        const hasService = hasPremiumServiceInCart(cart);
        const hasOtherProducts = cart.items.some((item) => item.handle !== PREMIUM_SERVICE_HANDLE);
        if (hasService && !hasOtherProducts) {
          e.preventDefault();
          e.stopPropagation();
          alert('The Wavon App cannot be purchased alone. Please add a Wavon Cushion to your cart first.');
          return false;
        }
      }
    }
  }, true);

  if (window.location.pathname.includes('/checkout')) {
    fetchCartSafe().then((cart) => {
      if (!cart) return;
      const hasService = hasPremiumServiceInCart(cart);
      const hasOtherProducts = cart.items.some((item) => item.handle !== PREMIUM_SERVICE_HANDLE);
      if (hasService && !hasOtherProducts) {
        alert('The Wavon App cannot be purchased alone. Please add a Wavon Cushion to your cart first.');
        window.location.href = '/cart';
      }
    });
  }

  // Pass cart data from event detail when available to skip the fetch
  document.addEventListener('cart:updated', (e) => {
    const cart = e.detail && e.detail.cart;
    scheduleCartCheck(cart && cart.items ? cart : null);
  });

  document.addEventListener('cart:refresh', () => {
    scheduleCartCheck(null);
  });

  document.addEventListener('cart:change', (e) => {
    const cart = e.detail && e.detail.cart;
    scheduleCartCheck(cart && cart.items ? cart : null);
  });

  // Initial check and setInterval only on /cart page
  if (window.location.pathname.includes('/cart')) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => {
        setTimeout(() => scheduleCartCheck(null), 1000);
      });
    } else {
      setTimeout(() => scheduleCartCheck(null), 1000);
    }
    setInterval(() => scheduleCartCheck(null), 10000);
  }

})();